module.exports = __webpack_public_path__ + "img/3.929dc22c.jpg";